var k = (T, x, s) => new Promise((f, c) => {
  var m = (a) => {
    try {
      l(s.next(a));
    } catch (w) {
      c(w);
    }
  }, h = (a) => {
    try {
      l(s.throw(a));
    } catch (w) {
      c(w);
    }
  }, l = (a) => a.done ? f(a.value) : Promise.resolve(a.value).then(m, h);
  l((s = s.apply(T, x)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { selfAxios as F } from "@oppein/op-utils";
import { postGetTechnicalReviewUrl as G } from "../../request/productionOrder/getTechnicalReviewUrl/post.js";
import { postBatchTransmit as H } from "../../request/engineering/EngineeringForeignTransmit/batchTransmit/post.js";
import { postCreate as q } from "../../request/engineering/bpmSpecialFlow/create/post.js";
import { defineComponent as J, computed as U, useTemplateRef as K, openBlock as j, createElementBlock as D, createElementVNode as u, createVNode as n, withCtx as o, createTextVNode as y, createCommentVNode as Q, Fragment as W } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as X } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as p, unref as i } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import g from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import _ from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
import Y from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/data-table/src/DataTable.js";
import { toDisplayString as Z } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
const ee = { class: "tw:flex tw:justify-center tw:gap-4" }, te = ["src"], ae = { class: "tw:flex tw:justify-end tw:items-center tw:gap-3 tw:mt-3" }, se = { class: "tw:text-gray-500" }, oe = { class: "tw:flex tw:justify-center tw:gap-4" }, he = /* @__PURE__ */ J({
  __name: "batchTransmit.ce",
  setup(T, { expose: x }) {
    const s = X(), f = p(!1), c = p(!1), m = p(!1), h = p(""), l = p([]), a = p(1), w = p(10), N = p(""), L = U(() => l.value.length), E = U(() => {
      const r = (a.value - 1) * w.value;
      return l.value.slice(r, r + w.value);
    }), C = K("modalContainer"), I = [
      { title: "订单合同自编号", key: "orderContractNo" },
      { title: "订单编号", key: "orderNo" }
    ], R = () => F.defaults.headers.common["Oauth2-AccessToken"] || "", V = () => {
      f.value = !1, window.addEventListener("message", A), c.value = !0;
    }, A = (r) => {
      r.data === "checkFinish" && (c.value = !1);
    }, z = () => {
      f.value = !1;
    }, P = () => {
      window.removeEventListener("message", A), f.value = !1;
    }, B = () => {
      m.value = !1;
    }, $ = () => k(this, null, function* () {
      const r = N.value;
      if (!r) {
        s.warning("业务类型不能为空");
        return;
      }
      const e = /* @__PURE__ */ new Set();
      try {
        yield Promise.all(
          l.value.map((t) => k(this, null, function* () {
            try {
              (yield q({
                applyDt: Date.now(),
                applyType: "bpm_process_judge",
                businessType: r,
                brand: t.brand,
                category: t.category,
                general: 0,
                orderId: t.id,
                reason: ""
              })) || (e.add(t.id), console.error(`订单 ${t.orderNo} 发起遗留判定流程未返回 URL`));
            } catch (v) {
              e.add(t.id), console.error(`订单 ${t.orderNo} 发起遗留判定流程失败`, v);
            }
          }))
        ), e.size === 0 ? (s.success("发起成功"), m.value = !1) : (s.warning("部分发起失败"), l.value = l.value.filter((t) => e.has(t.id)));
      } catch (t) {
        console.error("发起遗留判定流程失败", t), s.error("发起流程失败，请稍后重试");
      }
    });
    return x({ open: (r) => k(this, null, function* () {
      const { orders: e, businessType: t } = r;
      if (N.value = t, !e.length)
        return s.warning("您未勾选订单，无法批量传单！"), !1;
      let v = !0;
      if (e.forEach((d) => {
        (e[0].applyCode && d.applyCode !== e[0].applyCode || !e[0].applyCode && d.applyCode) && (v = !1);
      }), !v)
        return s.warning("所选订单不在同一个下单申请号,无法批量传单！"), !1;
      const M = e.map((d) => d.orderNo);
      try {
        const S = yield G({ orderNos: M });
        if (S)
          return h.value = S + "&Oauth2-AccessToken=" + R(), f.value = !0, !1;
      } catch (d) {
        console.error("获取技审检查URL失败", d);
      }
      const O = e.map((d) => d.id), b = yield H({ idsList: O });
      return b.status ? !0 : (b.code === "261050" && Array.isArray(b.data) && (l.value = b.data, a.value = 1, m.value = !0), !1);
    }) }), (r, e) => (j(), D(W, null, [
      u("div", {
        ref_key: "modalContainer",
        ref: C
      }, null, 512),
      n(i(_), {
        show: f.value,
        "onUpdate:show": e[0] || (e[0] = (t) => f.value = t),
        title: "传单",
        preset: "card",
        style: { width: "400px" },
        "mask-closable": !1,
        onAfterLeave: z,
        to: C.value || "body"
      }, {
        footer: o(() => [
          u("div", ee, [
            n(i(g), {
              type: "primary",
              size: "small",
              onClick: V
            }, {
              default: o(() => e[5] || (e[5] = [
                y("发起检查", -1)
              ])),
              _: 1,
              __: [5]
            }),
            n(i(g), {
              size: "small",
              onClick: z
            }, {
              default: o(() => e[6] || (e[6] = [
                y("取消", -1)
              ])),
              _: 1,
              __: [6]
            })
          ])
        ]),
        default: o(() => [
          e[7] || (e[7] = u("div", { class: "tw:text-center tw:px-4" }, " 系统检测到您当前选择的订单需要进行统一检查后才可进行传单，请点击下方的“发起检查”按钮，检查并通过后，再次传单 ", -1))
        ]),
        _: 1,
        __: [7]
      }, 8, ["show", "to"]),
      n(i(_), {
        show: c.value,
        "onUpdate:show": e[1] || (e[1] = (t) => c.value = t),
        title: "传单检查",
        preset: "card",
        style: { width: "85%" },
        "mask-closable": !1,
        onAfterLeave: P,
        to: C.value || "body"
      }, {
        default: o(() => [
          c.value ? (j(), D("iframe", {
            key: 0,
            src: h.value,
            width: "100%",
            height: "600px",
            frameBorder: "0",
            allow: "local-network-access"
          }, null, 8, te)) : Q("", !0)
        ]),
        _: 1
      }, 8, ["show", "to"]),
      n(i(_), {
        show: m.value,
        "onUpdate:show": e[4] || (e[4] = (t) => m.value = t),
        title: " ",
        preset: "card",
        style: { width: "720px" },
        "mask-closable": !1,
        onAfterLeave: B,
        to: C.value || "body"
      }, {
        footer: o(() => [
          u("div", oe, [
            n(i(g), {
              size: "small",
              onClick: B
            }, {
              default: o(() => e[10] || (e[10] = [
                y("取消", -1)
              ])),
              _: 1,
              __: [10]
            }),
            n(i(g), {
              type: "primary",
              size: "small",
              onClick: $
            }, {
              default: o(() => e[11] || (e[11] = [
                y("发起流程", -1)
              ])),
              _: 1,
              __: [11]
            })
          ])
        ]),
        default: o(() => [
          e[12] || (e[12] = u("div", { class: "tw:flex tw:items-start tw:gap-3 tw:mb-4" }, [
            u("div", { class: "tw:w-6 tw:h-6 tw:rounded-full tw:bg-red-500 tw:flex tw:items-center tw:justify-center tw:text-white tw:shrink-0 tw:text-lg tw:leading-none" }, " × "),
            u("div", { class: "tw:text-base" }, "系统检测到您的订单未发起遗留判定流程，请发起流程后再传单")
          ], -1)),
          n(i(Y), {
            columns: I,
            data: E.value,
            bordered: !0,
            "single-line": !1,
            size: "small"
          }, null, 8, ["data"]),
          u("div", ae, [
            u("span", se, "共" + Z(L.value) + "个订单", 1),
            n(i(g), {
              text: "",
              disabled: a.value <= 1,
              onClick: e[2] || (e[2] = (t) => a.value--)
            }, {
              default: o(() => e[8] || (e[8] = [
                y("上一页", -1)
              ])),
              _: 1,
              __: [8]
            }, 8, ["disabled"]),
            n(i(g), {
              text: "",
              disabled: a.value * w.value >= L.value,
              onClick: e[3] || (e[3] = (t) => a.value++)
            }, {
              default: o(() => e[9] || (e[9] = [
                y("下一页", -1)
              ])),
              _: 1,
              __: [9]
            }, 8, ["disabled"])
          ])
        ]),
        _: 1,
        __: [12]
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  he as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/batch-transmit/batchTransmit.ce.vue.js
// module id = 1175
// module chunks = 41